import { jwtDecode } from 'jwt-decode';
import { getUserPermissions } from "../api's/ManagementApi";
import { playSuccessSound } from '../utils/playSuccessSound';
import { apiRequest } from './authConfig';
import { AWS_CONFIG_TYPE } from '../BaseUrl';

/**
 * Finalizes MSAL sign-in: tokens, session storage, permissions, context, then navigates to dashboard.
 * Used after both loginPopup (in-page) and loginRedirect (return navigation).
 */
export default async function completeAzureSession({
  instance,
  redirectResult,
  navigate,
  enqueueSnackbar,
  setUser,
  setToken,
  setUserId,
  setUserGroup,
  setLLMId,
  setLLMName,
}) {
  const account = redirectResult?.account || instance.getAllAccounts()[0];
  if (!account) {
    throw new Error('No Azure account found.');
  }
  if (typeof instance.setActiveAccount === 'function') {
    instance.setActiveAccount(account);
  }

  let tokenResponse;
  try {
    tokenResponse = await instance.acquireTokenSilent({
      ...apiRequest,
      account,
    });
  } catch {
    tokenResponse = await instance.acquireTokenPopup({
      ...apiRequest,
      account,
    });
  }

  sessionStorage.setItem('jwtToken', tokenResponse.idToken);
  const accessToken = tokenResponse?.accessToken;
  const idClaims = account.idTokenClaims || (tokenResponse.idToken ? jwtDecode(tokenResponse.idToken) : {});
  const email = idClaims.email;
  sessionStorage.setItem('jwtToken', JSON.stringify(accessToken));
  sessionStorage.setItem('email', email);
  sessionStorage.setItem('full_name', JSON.stringify(idClaims.name));
  sessionStorage.setItem('version', JSON.stringify('2.0'));
  sessionStorage.setItem('userGroup', JSON.stringify('Group1'));
  sessionStorage.setItem('user', JSON.stringify(idClaims.name));
  sessionStorage.setItem('LLMId', AWS_CONFIG_TYPE ? 'llm-2' : 'llm-1');
  sessionStorage.setItem('LLMName', AWS_CONFIG_TYPE ? 'Bedrock' : 'ChatGPT');

  let userId = '';
  let userPermissions = [];
  try {
    const permissionsResponse = await getUserPermissions(email);
    userPermissions = permissionsResponse?.permissions || [];
    userId = permissionsResponse?.userId || '';
    sessionStorage.setItem('userPermissions', JSON.stringify(userPermissions));
    sessionStorage.setItem('id', JSON.stringify(userId));
  } catch (permError) {
    console.error('Failed to fetch user permissions:', permError);
  }

  playSuccessSound();
  enqueueSnackbar('Login successful!', { variant: 'success' });
  setUser(idClaims.name);
  setToken(accessToken);
  setUserId(userId);
  setUserGroup('Group1');
  setLLMId('llm-1');
  setLLMName('ChatGPT');
  navigate('/dashboard', { replace: true });
}
